var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfoCircleSmall = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 18C16.4779 18 19.5 14.9779 19.5 11.25C19.5 7.52208 16.4779 4.5 12.75 4.5C9.02208 4.5 6 7.52208 6 11.25C6 14.9779 9.02208 18 12.75 18ZM21 11.25C21 15.8063 17.3063 19.5 12.75 19.5C8.19365 19.5 4.5 15.8063 4.5 11.25C4.5 6.69365 8.19365 3 12.75 3C17.3063 3 21 6.69365 21 11.25ZM12.75 10.5C13.1642 10.5 13.5 10.8358 13.5 11.25V15.75C13.5 16.1642 13.1642 16.5 12.75 16.5C12.3358 16.5 12 16.1642 12 15.75V11.25C12 10.8358 12.3358 10.5 12.75 10.5ZM13.5 8.25C13.5 7.83579 13.1642 7.5 12.75 7.5C12.3358 7.5 12 7.83579 12 8.25C12 8.66421 12.3358 9 12.75 9C13.1642 9 13.5 8.66421 13.5 8.25Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoCircleSmall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/info-circle-small.7f9f3dee84650800461fc2dd444a6510.svg";